import { Injectable } from '@angular/core';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class AppConfigService {
  OpenWeatherApiKey = '9b3c08dbd48449fd26bbb25e6e51460b';
  stateList = [
    { name: 'SELANGOR', displayName: 'SELANGOR', latitude: 3.509247, longitude: 101.524803, bg: 'selangor-bg.png' },
    { name: 'KUALA LUMPUR', displayName: 'KUALA<br>LUMPUR', latitude: 3.139003, longitude: 101.686852, bg: 'kl-bg.png', doubleLine: true },
    { name: 'KEDAH', displayName: 'KEDAH', latitude: 6.155672, longitude: 100.569649, bg: 'kedah-bg.png' },
    { name: 'PENANG', displayName: 'PENANG', latitude: 5.285153, longitude: 100.456238, bg: 'penang-bg.png' },
    { name: 'JOHOR', displayName: 'JOHOR', latitude: 1.937344, longitude: 103.366585, bg: 'johor-bg.png' },
    { name: 'MELAKA', displayName: 'MELAKA', latitude: 2.189594, longitude: 102.250084, bg: 'melaka-bg.png' },
    { name: 'KELANTAN', displayName: 'KELANTAN', latitude: 6.125397, longitude: 102.238068, bg: 'kelantan-bg.png' },
    { name: 'PAHANG', displayName: 'PAHANG', latitude: 3.812632, longitude: 103.325623, bg: 'pahang-bg.png' },
    { name: 'PERAK', displayName: 'PERAK', latitude: 4.592113, longitude: 101.090111, bg: 'perak-bg.png' },
    { name: 'PERLIS', displayName: 'PERLIS', latitude: 6.443589, longitude: 100.216599, bg: 'perlis-bg.png' },
    { name: 'PUTRAJAYA', displayName: 'PUTRAJAYA', latitude: 2.93527, longitude: 101.69112, bg: 'putrajaya-bg.png' },
    { name: 'NEGERI SEMBILAN', displayName: 'NEGERI<br>SEMBILAN', latitude: 2.731813, longitude: 102.252502,
    bg: 'negeri-sembilan-bg.png', doubleLine: true },
  ]
  CoreAPIUrl = environment.apiUrl;
  PhotoMaxUploadSizeBytes: number = 1024 * 500;
  PhotoAllowedFileTypes: string[] = ['.jpg', '.jpeg', '.gif', '.png'];
  AbsoluteImagePath = `${this.CoreAPIUrl}/images`;
  HomeUrl = '/home';
  AccountUrl = '/account';
  LoginUrl = `${this.AccountUrl}/login`;
  RegisterUrl = `${this.AccountUrl}/register`;
  RecoveryUrl = `${this.AccountUrl}/recovery`;
  ForgotPasswordUrl = `${this.AccountUrl}/forgotPassword`;
  UnlockUrl = `${this.AccountUrl}/unlock`;
  ResetPasswordUrl = `${this.AccountUrl}/resetPassword`;
  MobileScreenSize = 576;
  TabletScreenSize = 768;
  ProductTypeList = [
    { label: 'Credit / Debit / Prepaid Card', value: 'CARDLINK'},
    { label: 'Deposit', value: 'DEPOSIT'},
    { label: 'Banca', value: 'BANCA'},
    { label: 'Wealth', value: 'WEALTH'},
    { label: 'EChannel', value: 'ECHANNEL'},
  ];

  CategoryList: any = [
    { icon: 'phone', label: 'Phones & Tablets', categoryId: 366 },
    { icon: 'home', label: 'Home Appliances', categoryId: 171 },
    { icon: 'baby', label: 'Baby & Kids', categoryId: 191 },
    { icon: 'health', label: 'Health & Beauty', categoryId: 181 },
    { icon: 'house', label: 'Home & Lifestyle', categoryId: 214 },
    { icon: 'car', label: 'Automotive', categoryId: 676 },
    { icon: 'computer', label: 'Computer & Stationery', categoryId: 203 },
    { icon: 'camera', label: 'Camera', categoryId: 168 },
    { icon: 'sports', label: 'Sports & Outdoors', categoryId: 438 },
    { icon: 'diamond', label: 'Bags & Jewelry', categoryId: 2024 },
    { icon: 'watch', label: 'Watches', categoryId: 230 },
    { icon: 'airplane', label: 'Travel & Luggage', categoryId: 2337 },
    { icon: 'voucher', label: 'Vouchers', categoryId: 2384 },
    { icon: 'grocery', label: 'Grocery', categoryId: 239 },
    { icon: 'fee', label: 'Fee Waiver', link: 'https://www.rhb.com.my' },
  ];

  private isSmallScreenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(false);
  private isMyrSubject: BehaviorSubject<any> = new BehaviorSubject<any>(localStorage.getItem('isMyr') ? localStorage.getItem('isMyr') === 'true' : true);
  private showOverlaySubject: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  getAppLocale() {
    const locale = sessionStorage.getItem('locale');
    // Supported locale 'en' or 'zh' ONLY
    return (locale !== 'zh') ? 'en' : locale;
  }


  public get currentMonth() {
    const dtNow = new Date();
    const currentMonth = moment([dtNow.getFullYear(), dtNow.getMonth()]);
    return currentMonth.format('YYYY-MM-DD');
  }

  public get currentYear() {
    const dtNow = new Date();
    const currentMonth = moment([dtNow.getFullYear()]);
    return currentMonth.format('YYYY-MM-DD');
  }

  public get isMyr(): any {
    return this.isMyrSubject.value;
  }

  public set isMyr(value) {
    this.isMyrSubject.next(value);
  }

  public get showOverlay(): any {
    return this.showOverlaySubject.value;
  }

  public set showOverlay(value) {
    this.showOverlaySubject.next(value);
  }

  public set isSmallScreen(value) {
    this.isSmallScreenSubject.next(value);
  }

  public get isSmallScreen(): any {
    return this.isSmallScreenSubject.value;
  }

  constructor() { }
}
